// extracted by mini-css-extract-plugin
module.exports = {"borderVertical":"InputOutputContainer_borderVertical_1H8rE"};